import React, { MouseEvent } from 'react';

interface TagIconProps {
  className?: string;
  onClick?: (event: MouseEvent) => void;
}

const TagIcon = ({ className, onClick }: TagIconProps) => {
  return (
    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
      <g clipPath="url(#clip0_2213_7284)">
        <path d="M13.3813 7.7375L7.75625 2.1125C7.53125 1.8875 7.21875 1.75 6.875 1.75H2.5C1.8125 1.75 1.25 2.3125 1.25 3V7.375C1.25 7.71875 1.3875 8.03125 1.61875 8.2625L7.24375 13.8875C7.46875 14.1125 7.78125 14.25 8.125 14.25C8.46875 14.25 8.78125 14.1125 9.00625 13.8813L13.3813 9.50625C13.6125 9.28125 13.75 8.96875 13.75 8.625C13.75 8.28125 13.6062 7.9625 13.3813 7.7375ZM8.125 13.0063L2.5 7.375V3H6.875V2.99375L12.5 8.61875L8.125 13.0063Z" fill="#191B1E"/>
        <path d="M4.0625 5.5C4.58027 5.5 5 5.08027 5 4.5625C5 4.04473 4.58027 3.625 4.0625 3.625C3.54473 3.625 3.125 4.04473 3.125 4.5625C3.125 5.08027 3.54473 5.5 4.0625 5.5Z" fill="#191B1E"/>
      </g>
      <defs>
        <clipPath id="clip0_2213_7284">
          <rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default TagIcon;